export default "__VITE_ASSET__C3cAk3Tw__"